
/* injects from baggage-loader */

export const PlatesType = {
    entrance: 1,
    principal: 2,
    dessert: 3,
    drink: 4
}


// WEBPACK FOOTER //
// ./src/app/components/ui/types/plates.js